import '../app.es6';
import angular from 'angular';

const COMPONENT_NAME = 'breadCrumb';
const REPLACE_MEMBER_NAME = '__REPLACE_MEMBER_NAME__';
const REPLACE_SCHOOL_NAME = '__REPLACE_SCHOOL_NAME__';
const BREADCRUMB_CONFIG_FILE = './config/breadcrumbs-config.json';

class BreadCrumb {
  /* @ngInject */
  constructor ($sessionStorage, $element, $http, Const) {
    this.Const = Const;
    this.$sessionStorage = $sessionStorage;
    let controller = $element[0].attributes.controller.value;
    let jsonFilePath = BREADCRUMB_CONFIG_FILE;
    $http.get(jsonFilePath)
      .success((datas) => {
        this.breadcrumbs = [];
        datas.forEach((data) => {
          if (controller === data.controllerName) {
            data.breadcrumbs.forEach((breadcrumb) => {
              this.setBreadcrumb(breadcrumb);
            });
          }
        });
      });

    BreadCrumb.$inject = ['$sessionStorage', '$element', '$http', 'Const'];
  }

  setBreadcrumb (breadcrumb) {
    if (this.isContainsName(breadcrumb)) {
      breadcrumb = this.replaceParam(breadcrumb);
    }
    this.breadcrumbs.push(breadcrumb);
  }

  replaceParam (breadcrumb) {
    breadcrumb.viewName = breadcrumb.viewName.replace(REPLACE_MEMBER_NAME, this.$sessionStorage[this.Const.SSAPP_USER_NAME]);
    breadcrumb.viewName = breadcrumb.viewName.replace(REPLACE_SCHOOL_NAME, this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME]);
    return breadcrumb;
  }

  isContainsName (breadcrumb) {
    return breadcrumb.viewName.match(REPLACE_MEMBER_NAME) || breadcrumb.viewName.match(REPLACE_SCHOOL_NAME);
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME
    },
    controller: BreadCrumb,
    // TODO : webpack対応でhtmlをimportするよう修正する
    templateUrl: 'app/components/templates/bread-crumb.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/bread-crumb.es6